import React from 'react';
import styles from '../css/ErrorModal.module.css';
import { useDispatch } from 'react-redux';
import { FiX } from 'react-icons/fi';
import { AiOutlineReload } from 'react-icons/ai';

const CrashError = ({msg,retry,closeMenu}) => {
    const dispatch = useDispatch()

    const handleRetry = () => {
        dispatch({type: "CLEAR_ERROR"})
        retry()
    }

    return (
        <div data-testid = "crash-box" className = {styles.wrapper}>
            <div className={`${styles.popup} ${styles.crash}`}>
                <button type = "button" className={styles.close} onClick = {()=>closeMenu()}>
                    <FiX/>
                </button>
                <div className={styles.inner}>
                    <div className={styles.illus}>
                        <img
                            src="/assets/500Error.png"
                            alt="500 ERROR"
                            loading="lazy"
                        />
                    </div>
                    <div className={styles.text}>
                        <div className={styles.eyebrow}>Error 500</div>
                        <div className={styles.title}>
                            Oops, something<br />
                            <em>went wrong.</em>
                        </div>
                        <div className={styles.desc}>
                            {msg}
                        </div>
                        <div>
                            <button type = "button" className={styles.tryBtn} onClick = {()=>handleRetry()}>
                                Try Again
                            <div className={styles.btnIcon}>
                                <AiOutlineReload/>
                            </div>
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default CrashError